export default __webpack_public_path__ + "static/media/image_gc.eaf86de8.jpg";